import store from './store'
import update from './update'

const namespaced = true

export default {
  namespaced,
  modules: {
    store,
    update
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/topics/forms/index.js